import { render } from "./DictionaryItems.vue?vue&type=template&id=4d8041ed&scoped=true"
import script from "./DictionaryItems.vue?vue&type=script&lang=js"
export * from "./DictionaryItems.vue?vue&type=script&lang=js"

import "./DictionaryItems.vue?vue&type=style&index=0&id=4d8041ed&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8041ed"]])

export default __exports__